import { api } from 'src/services/api'

type Params = {
  key: string
}

type Response = {
  status: boolean
}

export async function deletePixKey({ key }: Params) {
  try {
    const token = localStorage.getItem('@stricv2:token')
    const user = await JSON.parse(localStorage.getItem('@stricv2:user')!)

    if (user.role === 'ADMIN_BAG') {
      const response = await api.post<Response>(
        `/pix/delete/key/admin`,
        {
          key,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    } else {
      const response = await api.post<Response>(
        `/pix/delete/key`,
        {
          key,
          account_id: user.virtual_account_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    }
  } catch (error) {
    console.error(error)
  }
}
